export class csvGenerator {

    // data is expected to be an array containing arrays for each line, starting with the header, as described bellow:
    // [[header1,header2,headerN],
    //  [line1-1,line1-2,line1-3],
    //  [lineN-1,lineN-2,lineN-3]]
    static toCSV(filename, data) {
        let content = '';
        let line = null;
        for(let i = 0; i < data.length; i++) {
            line = data[i]

            for(let j = 0; j < line.length; j++) {
                if (typeof(line[j]) === 'string' && !/[a-zA-Z]+/.test(line[j])){
                    line[j] = line[j].replaceAll('.',',').replaceAll(' ','');
                }
            }

            content += line.join(';')
            if(i < data.length - 1) {
                content += '\r\n'
            }
        }

        var link = document.createElement('a');
        link.download = filename;
        var blob = new Blob(["\ufeff\ufeff", content], { type: 'text/csv;charset=utf-8' });
        link.href = window.URL.createObjectURL(blob);
        link.click();
    }
}